import { render, staticRenderFns } from "./sales.vue?vue&type=template&id=9e4a9c1e&"
import script from "./sales.ts?vue&type=script&lang=ts&"
export * from "./sales.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports